/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useLayoutEffect } from 'react';
import { Helmet } from 'react-helmet';
import Article from './Article/Article';

import { useSetRecoilState } from 'recoil';
import { isHeaderBlackState } from '../../store/atoms';

import styled from 'styled-components';

export default function News() {
  const setIsHeaderBlackState = useSetRecoilState(isHeaderBlackState);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useLayoutEffect(() => {
    setIsHeaderBlackState(false);
  }, []);

  return (
    <>
      <Helmet>
        <meta property="og:description" content="언론에 소개된 인텔리퀀트" />
        <meta name="description" content="언론에 소개된 인텔리퀀트" />
      </Helmet>
      <StyledNews>
        <StyledNewsContentsContainer>
          <StyledTag>OUR NEWS</StyledTag>
          <StyledTitle>
            언론에 소개된 인텔리퀀트를 <br />
            만나보세요.
          </StyledTitle>
        </StyledNewsContentsContainer>
        <StyledNewsArticleContainer>
          {NEWS_ARTICLE.map(
            ({ title, pressImage, pubdate, desc, publisher, link }, index) => {
              return (
                <Article
                  key={index + 1}
                  title={title}
                  pressImage={pressImage}
                  publisher={publisher}
                  pubdate={pubdate}
                  desc={desc}
                  link={link}
                />
              );
            }
          )}
        </StyledNewsArticleContainer>
      </StyledNews>
    </>
  );
}

const StyledNews = styled.section`
  max-width: 1340px;
  padding: 0 30px;
  margin: 184px auto 0;

  ${({ theme }) => theme.mobile`
    margin: 130px auto 0;
    padding: 0 30px;
  `}
`;

const StyledNewsContentsContainer = styled.article`
  margin-bottom: 100px;

  ${({ theme }) => theme.mobile`
    margin-bottom: 70px;
  `}
`;

const StyledTag = styled.h1`
  margin-bottom: 18px;
  color: ${({ theme }) => theme.colors.green};
  font-size: ${({ theme }) => theme.pixelToRem(14)};

  ${({ theme }) => theme.mobile`
  margin-bottom: 10px;

  `}
`;

const StyledTitle = styled.h2`
  font-size: ${({ theme }) => theme.pixelToRem(30)};
  font-weight: 700;
`;

const StyledNewsArticleContainer = styled.ul`
  margin: 0 auto 350px;
  ${({ theme }) => theme.flex('row', 'space-between', 'stretch')}
  bottom: 100px;
  flex-wrap: wrap;

  ${({ theme }) => theme.mobile`
  margin: 0 auto 97px;
  `}

  li:nth-child(even) {
    position: relative;
    top: 150px;

    ${({ theme }) => theme.mobile`
      position: static;
    `}

    &:nth-child(4) {
      div:first-child {
        background-size: 105%;
      }
    }
  }
`;

const NEWS_ARTICLE = [
  {
    title: '[바스리] 개인이 만든 투자 알고리즘을 사고판다',
    pressImage: '/images/News/press_20.jpeg',
    publisher: '바이라인 네트워크',
    pubdate: '2021.12.27',
    desc: '주식 투자를 하면서 이런 아쉬운 소리가 나올 때가 많습니다. 세상 일 내 마음대로 되지 않는다고 하던데, 투자는 더더욱 그렇습니다. 그런데, 사용자가 원하는 시점에 주식을 매수하고 매도할 수 있는 투자 알고리즘을 만들 수 있는 곳이 있다고 합니다. 개발 좀 할 줄 아는 사용자라면 직접 인텔리퀀트의 서비스에서 투자 알고리즘을 설계하고 만들어 실전에서 활용할 수 있도록 했다는데요. 로보어드바이저 스타트업 인텔리퀀트가 이러한 서비스를 제공하고 있습니다.',
    link: 'https://byline.network/2021/12/27-171/',
  },
  {
    title: '인텔리퀀트, 알고리즘 투자플랫폼 업그레이드…”미국주식도 직접 투자”',
    pressImage: 'images/News/press_1-1.png',
    publisher: '세계일보',
    pubdate: '2021.06.28',
    desc: '알고리즘 투자플랫폼 ‘인텔리퀀트 스튜디오’를 서비스하고 있는 ㈜인텔리퀀트가 국내 주식에 이어 미국 주식으로 그 대상을 확대하며 서비스를 업그레이드한다고 28일 밝혔다.',
    link: 'http://www.segyebiz.com/newsView/20210628509775?OutUrl=naver',
  },
  {
    title: '랜드박스, 인텔리퀀트와 MOU 체결..비트코인 정기구매 서비스 개발',
    pressImage: '/images/News/press_2.jpeg',
    publisher: '한국정경신문',
    pubdate: '2021.01.28',
    desc: '프롭테크 전문기업 넥스트아이비의 글로벌 부동산 투자 정보 공유 플랫폼 ‘랜드박스(LANDBOX)’가 인텔리퀀트와 27일 디지털 자산 운용 서비스에 대한 공동 연구·개발 MOU를 체결했다.',
    link: 'http://kpenews.com/View.aspx?No=1427548',
  },
  {
    title:
      '초연결 지능화 시대 이끌 ‘100대 혁신기업’ 들여다보니... 빅데이터·네트워크·AI 기업 주목',
    pressImage: '/images/News/press_3.jpg',
    publisher: '매일경제',
    pubdate: '2019.03.06',
    desc: '“AI가 모든 산업을 재정의할 것이다. AI를 제패하는 기업이 미래를 지배한다. 앞으로 AI와 관련 없는 기업에는 투자하지 않겠다.”',
    link: 'https://www.mk.co.kr/news/business/view/2019/03/135515/',
  },
  {
    title:
      '알고리즘 기반 투자플랫폼 인텔리퀀트, 비티씨인베스트먼트로부터 투자 유치',
    pressImage: '/images/News/press_4-1.png',
    publisher: '전자신문',
    pubdate: '2018.12.19',
    desc: '인텔리퀀트(대표 이종권)가 투자사인 비티씨인베스트먼트로부터 5억원 규모의 투자 유치 소식을 알렸다. 인텔리퀀트는 알고리즘 기반 투자플랫폼 서비스를 제공하는 핀테크 스타트업이다.',
    link: 'https://www.etnews.com/20181219000169',
  },
  {
    title: '개미투자자도 "알고리즘" 도움 받을 수 있다?',
    pressImage: '/images/News/press_5.jpg',
    publisher: '머니투데이방송',
    pubdate: '2018.09.18',
    desc: '개미투자자들도 "알고리즘" 트레이딩을 쉽게 펼칠 수 있게 됐다. NH투자증권이 18일 알고리즘을 기반으로 한 주식투자 솔루션 "알고리즘 마켓"을 선보였다.',
    link: 'https://news.mtn.co.kr/issue/viewer.mtn?gidx=2018091816074087897',
  },
  {
    title: '퀀트 투자에 푹 빠진 개미들',
    pressImage: '/images/News/press_6.jpg',
    publisher: '한경닷컴',
    pubdate: '2018.04.16',
    desc: '기관투자가들의 전유물이던 ‘퀀트 투자(계량 투자)’가 개인 투자자 사이에서도 유행처럼 번지고 있다. 퀀트 투자란 오로지 ‘숫자’에만 기반해 투자 결정을 내리는 방식이다.',
    link: 'https://www.hankyung.com/finance/article/2018041649781',
  },
  {
    title: '코스콤 1차 테스트베드 결과…로보어드바이저 수익률 1.6%',
    pressImage: '/images/News/press_7.jpg',
    publisher: '매일경제',
    pubdate: '2017.04.30',
    desc: '국내 자산에 투자하는 로보어드바이저 중에선 "SK-쿼터백 ROBO 1호"(7.12%), "파운트펀드"(4.86%), "불리오"(4.67%), "아이콘-알파"(4.24%), "위즈봇2호"(4.22%)가 뒤를 이었다.',
    link: 'https://www.mk.co.kr/news/stock/view/2017/04/292679/',
  },
  {
    title: '[로보어드바이저 기획] 인텔리퀀트, 챗봇으로 고객상담까지 차별화',
    pressImage: '/images/News/press_8.jpg',
    publisher: '세계일보',
    pubdate: '2017.04.28',
    desc: '로보어드바이저는 투자 의사결정과 프로세스를 인공지능으로 자동화한다. 사람이 하던 일을 대신하는 것이다. 이는 인공지능이 사람보다 더 효과적이거나 더 좋은 결과를 낼 수 있다는 생각 때문이다. 인텔리퀀트는.',
    link: 'https://www.techm.kr/news/articleView.html?idxno=3896',
  },
  {
    title: "MBC 2016 창사특집 다큐멘터리 '미래인간 AI'",
    pressImage: '/images/News/press_9.png',
    publisher: 'mbc',
    pubdate: '2016.12.12',
    desc: '이에 인간 주식 전문가가 인공지능에 도전장을 내밀었다.자타 공인 증권가 마이더스의 손 신영목 이사가 떠오르는 신예 로보어드바이저 업체 인텔리퀀트를 상대로1억 원의 가상 금액을 두고 펼치는 모의 투자에 나선 것!.',
    link: 'http://m.imbc.com/VOD/VodView?progCode=1003412100000100000&broadcastID=1003412100002100000&type=Prevod',
  },
  {
    title: "로보어드바이저 'DNA인텔리퀀트', 트럼프 쇼크 뛰어넘다",
    pressImage: '/images/News/press_10.jpg',
    publisher: '뉴스핌',
    pubdate: '2016.11.18',
    desc: 'DNA-인텔리퀀트-예스스탁 돋보여 18일 금융투자업계에 따르면 트럼프 당선 당일(한국기준 9일)부터 지난 16일 종가까지 코스콤이 운영하는 로보어드바이저 테스트베드에서 가장 높은 수익을 낸 것은.',
    link: 'https://www.newspim.com/news/view/20161118000154',
  },
  {
    title: '한화생명, 핀테크 육성센터 ‘드림플러스 63’출범',
    pressImage: '/images/News/press_11.jpg',
    publisher: '헤럴드경제',
    pubdate: '2016.10.13',
    desc: '한화생명 차남규 사장(가운데)이 핀테크센터에 입주한 인텔리퀀트, (주)핀테크 등 11개 핀테크 스타트업 대표들과 기념촬영을 하고 있다. 한화생명은 지난 7월 핀테크센터에 입주할 스타트업을 공개 모집해 사업 내용.',
    link: 'http://news.heraldcorp.com/view.php?ud=20161013000336',
  },
  {
    title: '한화證, 로보어드바이저 자산관리 서비스 ‘스마트 로보Q’ 출시',
    pressImage: '/images/News/press_12.jpg',
    publisher: '서울경제',
    pubdate: '2016.07.18',
    desc: '스마트 로보Q는 인공지능 자산관리 전문업체인 ㈜인텔리퀀트와의 제휴를 통해 만들어 졌다. 고객의 투자성향과 투자금액을 기반으로 각자에게 맞는 최적의 포트폴리오 구성을 돕는다.',
    link: 'https://www.sedaily.com/NewsVIew/1KYWW8T83B',
  },
  {
    title: "석달간의 수익률 대결 최종 승자는…AI '위험 관리' 시스템 빛났다",
    pressImage: '/images/News/press_13.jpg',
    publisher: '한국경제TV',
    pubdate: '2016.07.03',
    desc: '특히 대회 초반부터 줄곧 상위권을 유지해온 인텔리퀀트사의 ‘아이콘’은 누적 수익률 4.55%로 이번 대회 우승을 차지했다.',
    link: 'https://www.hankyung.com/news/article/2016070326161',
  },
  {
    title: '[인공지능 VS. 주식고수 수익률 빅매치] 인공지능, 자산관리 새길 열다',
    pressImage: '/images/News/press_14.gif',
    publisher: '한국경제TV',
    pubdate: '2016.07.01',
    desc: "탁월한 분석력을 기반으로 대회 초반부터 인간을 따돌려온 인텔리퀀트사의 인공지능 아이콘은 '영원한 1등은 없다'는 고정관념을 깨고 결국 우승을 차지했습니다.",
    link: 'https://www.wowtv.co.kr/NewsCenter/News/Read?articleId=A201607010249',
  },
  {
    title: "인공지능 '아이콘' 독주…인간팀, 투자종목 축소 '집중화 전략'",
    pressImage: '/images/News/press_16.jpg',
    publisher: '한국경제TV',
    pubdate: '2016.05.08',
    desc: '대회 6주차 누적수익률 12.31%로 1위를 달리고 있는 인텔리퀀트의 ‘아이콘’은 자신이 보유하고 있는 12개 종목 중 4개 종목을 교체했다.',
    link: 'https://www.hankyung.com/news/article/2016050826761',
  },
  {
    title: '[증시라인10] 수익률 빅매치···아이콘(AI), 압도적 1위 질주',
    pressImage: '/images/News/press_17.jpg',
    publisher: '한국경제TV',
    pubdate: '2016.04.07',
    desc: '[증시라인10] 수익률 빅매치 캐스터: 김수아 인공지능팀 : 아이콘(인텔리퀀트), 라씨(씽크풀), 슈팅스타(드라코랩스) 인간팀 : 신영목 메리츠종금증권 이사, 김우식 SK증권 부장 이종일 한국투자증권 부장',
    link: 'https://www.wowtv.co.kr/NewsCenter/News/Read?articleId=A201604070271&resource=',
  },
];
